<template>
  <v-container style="max-width: 1800px !important">
    <div class="pa-3 ma-3">
      <mostrar-detalles
      ref="mostrar_detalles"
    >
    </mostrar-detalles>

    <cuenta-bancarias
      ref="cuenta_bancarias"
    >
    </cuenta-bancarias>

      <v-dialog v-model="dialogAddEdit" max-width="90%" persistent>
        <v-alert-dialog ref="alert"> </v-alert-dialog>
        <v-card>
          <v-card-title>
            {{ editedItem.id_proveedor === null ? "Crear" : "Editar" }}
            Proveedor
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12" class="text-center">
                <h3>Información Básica</h3>
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                  :items="proveedorTipos"
                  v-model="editedItem.id_proveedor_tipo"
                  label="Tipo de Proveedor"
                  item-value="id_proveedor_tipo"
                  item-text="nombre"
                  dense
                  outlined
                  hide-details
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                  :items="personaTipos"
                  v-model="editedItem.id_persona_tipo"
                  label="Tipo de Persona"
                  item-value="id_persona_tipo"
                  item-text="nombre"
                  dense
                  outlined
                  hide-details
                ></v-autocomplete>
              </v-col>
              <template
                v-if="
                  editedItem.id_proveedor_tipo ==
                  'b1921daf-3922-47ad-8a80-33a0299babe5'
                "
              >
                <v-col cols="12" md="6">
                  <v-select
                    label="Tipo de Proveedor Nacional*"
                    dense
                    outlined
                    hide-details
                    v-model="editedItem.id_proveedor_actividad"
                    :items="proveedorActividades"
                    item-text="nombre"
                    item-value="id_proveedor_actividad"
                  >
                  </v-select>
                </v-col>
              </template>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="editedItem.nombre_completo"
                  label="Nombre comercial *"
                  dense
                  outlined
                  hide-details
                >
                </v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="editedItem.nombre_contacto"
                  label="Nombre del Contacto *"
                  dense
                  outlined
                  hide-details
                >
                </v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-autocomplete-telefono
                  label="Teléfono Empresarial/Sucursal *"
                  v-model="editedItem.telefono"
                  url-get="/Catalogos/ListarPaises"
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="editedItem.correo_electronico"
                  label="Correo Electrónico *"
                  dense
                  outlined
                  hide-details
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="text-center">
                <h3>Datos Fiscales</h3>
              </v-col>
              <!-- Datos Fiscales Nacionales -->
              <template
                v-if="
                  editedItem.id_proveedor_tipo ==
                  'b1921daf-3922-47ad-8a80-33a0299babe5'
                "
              >
                <v-col cols="12" md="6">
                  <v-autocomplete
                    :items="regimenFiscales"
                    label="Régimen Fiscal *"
                    item-text="nombre"
                    item-value="id_regimen_fiscal"
                    dense
                    outlined
                    hide-details
                    v-model="editedItem.id_regimen_fiscal"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Nombre/Razón Social *"
                    dense
                    outlined
                    hide-details
                    v-model="editedItem.razon_social"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <RFCField
                    v-model="editedItem.rfc"
                    :idProveedor="editedItem.id_proveedor"
                    :idPersonaTipo="editedItem.id_persona_tipo"
                  >
                  </RFCField>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    label="Calle *"
                    dense
                    outlined
                    hide-details
                    v-model="editedItem.calle"
                  ></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    label="Núm Exterior *"
                    dense
                    outlined
                    hide-details
                    v-model="editedItem.num_ext"
                  ></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    label="Núm Interior"
                    dense
                    outlined
                    hide-details
                    v-model="editedItem.num_int"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-autocomplete
                    :items="estados"
                    label="Estado *"
                    item-value="id_estado"
                    item-text="nombre"
                    dense
                    outlined
                    hide-details
                    @change="getMunicipios"
                    v-model="editedItem.id_estado"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <v-autocomplete
                    :items="municipios"
                    item-value="id_municipio"
                    item-text="nombre"
                    label="Municipio *"
                    dense
                    outlined
                    hide-details
                    :loading="loadingMunicipios"
                    v-model="editedItem.id_municipio"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Localidad *"
                    dense
                    outlined
                    hide-details
                    v-model="editedItem.localidad"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Colonia *"
                    dense
                    outlined
                    hide-details
                    v-model="editedItem.colonia"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Código Postal *"
                    dense
                    outlined
                    hide-details
                    v-model="editedItem.codigo_postal"
                  ></v-text-field>
                </v-col>
              </template>

              <!-- Datos Fiscales Internacionales -->
              <template
                v-if="
                  editedItem.id_proveedor_tipo ==
                  '733d857a-5692-40d7-b47c-dd0c70da0394'
                "
              >
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Nombre/Razón Social *"
                    dense
                    outlined
                    hide-details
                    v-model="editedItem.razon_social"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Número de Identificación Fiscal *"
                    dense
                    outlined
                    hide-details
                    v-model="editedItem.numero_fiscal"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    label="Calle *"
                    dense
                    outlined
                    hide-details
                    v-model="editedItem.calle"
                  ></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    label="Núm Exterior *"
                    dense
                    outlined
                    hide-details
                    v-model="editedItem.num_ext"
                  ></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    label="Núm Interior"
                    dense
                    outlined
                    hide-details
                    v-model="editedItem.num_int"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Código Postal *"
                    dense
                    outlined
                    hide-details
                    v-model="editedItem.codigo_postal"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Ciudad *"
                    dense
                    outlined
                    hide-details
                    v-model="editedItem.ciudad"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Región/Estado/Provincia *"
                    dense
                    outlined
                    hide-details
                    v-model="editedItem.region"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-autocomplete
                    :items="paises"
                    label="País *"
                    item-value="id_pais"
                    item-text="nombre"
                    dense
                    outlined
                    hide-details
                    v-model="editedItem.id_pais"
                  ></v-autocomplete>
                </v-col>
              </template>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn color="green" text @click="closeDialogAddEdit">
              Cerrar
            </v-btn>
            <v-spacer> </v-spacer>
            <v-btn
              color="red"
              text
              :loading="saving"
              :disabled="saving"
              @click="save">
              Guardar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-row>
        <v-col cols="6">
          <v-btn color="primary" @click="openDialogAddParcial(null)">
            Agregar Proveedor Registro Parcial
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        
        <v-col cols="3">
          <v-text-field
            v-model="search.nombre"
            label="Nombre del Proveedor"
            dense
            outlined
            hide-details
            clearable
          >
          </v-text-field>
        </v-col>

        <v-col cols="3">
          <v-text-field
            v-model="search.email"
            label="Correo Electrónico"
            dense
            outlined
            hide-details
            clearable
          >
          </v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="search.rfc"
            label="RFC"
            dense
            outlined
            hide-details
            clearable
          >
          </v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="search.num_proveedor"
            label="# Proveedor"
            dense
            outlined
            hide-details
            clearable
          >
          </v-text-field>
        </v-col>

        <v-col cols="3">
          <v-autocomplete
            v-model="search.id_proveedor_tipo"
            item-value="id_proveedor_tipo"
            item-text="nombre"
            :items="proveedorTipos"
            label="Tipo de Proveedor"
            dense
            outlined
            hide-details
            clearable
          ></v-autocomplete>
        </v-col>

        <v-col cols="3">
          <v-autocomplete
            v-model="search.estado"
            item-value="id"
            item-text="nombre"
            :items="proveedorEstados"
            label="Estado"
            dense
            outlined
            hide-details
            clearable
          >
          </v-autocomplete>
        </v-col>

        <v-col cols="3">
          <v-autocomplete
            v-model="search.id_proveedor_nivel"
            item-value="id_proveedor_nivel"
            item-text="nombre"
            :items="proveedorNiveles"
            label="Nivel de Proveedor"
            dense
            outlined
            hide-details
            clearable
          ></v-autocomplete>
        </v-col>

        <v-col cols="3">
          <v-btn block color="primary" text outlined @click="getItems">
            <v-icon>mdi-magnify</v-icon>
            Buscar
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :loading="loading"
            :headers="headers"
            :items="items"
            :item-class="getRowClass"
          >
            <template v-slot:[`item.estado`]="{ item }">
              <!-- 🔴 BLOQUEADO -->
              <v-tooltip bottom v-if="item.bloqueado">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    color="red"
                  >
                    mdi-lock-alert
                  </v-icon>
                </template>
                <span>
                  Bloqueado
                  <template v-if="item.motivo_bloqueo">
                    <br>
                    {{ item.motivo_bloqueo }}
                    <br>
                    {{ item.usuario_bloqueo }}
                    <br>
                    Desde {{ item.bloqueado_desde }}
                  </template>
                </span>
              </v-tooltip>

              <!-- 🟡 SIN VALIDAR -->
              <v-tooltip bottom v-else-if="!item.validado">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    color="orange"
                  >
                    mdi-file-clock-outline
                  </v-icon>
                </template>
                <span>Pendiente de validación</span>
              </v-tooltip>

              <!-- 🟢 OK -->
              <v-tooltip bottom v-else>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    color="green"
                  >
                    mdi-check-circle
                  </v-icon>
                </template>
                <span>Validado</span>
              </v-tooltip>
            </template>

            
            <template v-slot:[`item.actions`]="{ item }">
              <!--
              <v-icon
                class="mr-2" small @click="openDialogView(item)">
                mdi-eye
              </v-icon>
              -->

              <v-tooltip v-if="item.id_proveedor_nivel == 'bd41d3c7-3e27-4ad4-9002-0099e6e44f76'" bottom color="black">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mr-2"
                    small
                    @click="openDialogCuentaBancariasView(item)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-bank
                  </v-icon>
                </template>
                <span>Ver Cuentas Bancarias</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import axios from "axios";
//import { mapState } from 'vuex';
import RFCField from "../Proveedores/RFCField.vue";
import MostrarDetalles from '../Proveedores/MostrarDetalles.vue';
import CuentaBancarias from '../Proveedores/CuentaBancarias.vue'

export default {
  components: {
    RFCField,
    MostrarDetalles,
    CuentaBancarias
  },
  data: () => ({
    proveedorNiveles: [],
    loadingProveedorNivel: false,

    proveedorTipos: [],
    loadingProveedorTipos: false,

    personaTipos: [],
    loadingPersonaTipos: false,

    proveedoActividades: [],
    loadingProveedorActividad: false,

    regimenFiscales: [],
    loadingRegimenFiscales: false,

    estados: [],
    loadingEstados: false,

    municipios: [],
    loadingMunicipios: false,

    paises: [],
    loadingPaises: false,

    proveedorEstados: [
      { id: 1, nombre: 'Validado'},
      { id: 2, nombre: 'Pendiente de Validación'},
      { id: 3, nombre: 'Bloqueado'},
    ],

    search: {
      id_proveedor_tipo: null,
      nombre: null,
      email: null,
      rfc: null,
      num_proveedor: null,
      estado: null,
      id_proveedor_nivel: null,
    },
    headers: [
      {
        text: "Estado",
        value: "estado",
        align: "center",
      },
      {
        text: "Clave del Proveedor",
        value: "clave",
        align: "center",
      },
      {
        text: "Nombre comercial",
        value: "nombre_completo",
        align: "center",
      },
      {
        text: "Tipo de Persona",
        value: "nombre_persona_tipo",
        align: "center",
      },
      {
        text: "Nivel de Proveedor",
        value: "nombre_proveedor_nivel",
        align: "center",
      },
      {
        text: "Tipo de Proveedor",
        value: "nombre_proveedor_tipo",
        align: "center",
      },

      {
        text: "Nombre del Contacto",
        value: "nombre_contacto",
        align: "center",
      },

      {
        text: "Teléfono de Contacto",
        value: "telefono",
        align: "center",
      },

      {
        text: "Correo Electrónico",
        value: "correo_electronico",
        align: "center",
      },

      {
        text: "Acciones",
        value: "actions",
        sortable: false,
        align: "center",
      },
    ],
    items: [],
    loading: false,

    dialogAddEdit: false,
    editedItem: {
      id_proveedor: null,
      // Catálogos
      id_proveedor_tipo: null, // Guid
      id_persona_tipo: null, // Guid

      // UI / validación
      bloquear_rfc: false, // bool

      // Nacional
      rfc: null, // string
      id_proveedor_actividad: null, // Guid

      // Generales
      nombre_completo: null, // string
      nombre_contacto: null, // string
      correo_electronico: null, // string
      telefono: null, // string

      // Dirección
      calle: null,
      num_ext: null,
      num_int: null,

      // Fiscales nacionales
      razon_social: null,
      id_estado: null, // int
      id_municipio: null, // Guid
      id_regimen_fiscal: null, // Guid
      codigo_postal: null,
      localidad: null,
      colonia: null,

      // Fiscales internacionales
      numero_fiscal: null,
      ciudad: null,
      region: null,
      id_pais: null, // Guid
    },
    defaultEditedItem: {
      id_proveedor: null,
      // Catálogos
      id_proveedor_tipo: null, // Guid
      id_persona_tipo: null, // Guid

      // UI / validación
      bloquear_rfc: false, // bool

      // Nacional
      rfc: null, // string
      id_proveedor_actividad: null, // Guid

      // Generales
      nombre_completo: null, // string
      nombre_contacto: null, // string
      correo_electronico: null, // string
      telefono: null, // string

      // Dirección
      calle: null,
      num_ext: null,
      num_int: null,

      // Fiscales nacionales
      razon_social: null,
      id_estado: null, // int
      id_municipio: null, // Guid
      id_regimen_fiscal: null, // Guid
      codigo_postal: null,
      localidad: null,
      colonia: null,

      // Fiscales internacionales
      numero_fiscal: null,
      ciudad: null,
      region: null,
      id_pais: null, // Guid
    },
    saving: false,
  }),
  mounted() {
    this.getProveedorNiveles();
    this.getProveedorTipos();
    this.getPersonaTipos();
    this.getProveedorActividades();
    this.getRegimenFiscales();
    this.getEstados();
    this.getPaises();
    this.getItems();
  },
  methods: {
    getProveedorNiveles() {
      this.loadingProveedorNivel = true;
      axios
        .get("/Proveedores/ListarProveedorNiveles")
        .then((response) => {
          this.proveedorNiveles = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loadingProveedorNivel = false;
        });
    },
    getProveedorTipos() {
      this.loadingProveedorTipos = true;
      axios
        .get("/Proveedores/ListarProveedorTipos")
        .then((response) => {
          this.proveedorTipos = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loadingProveedorTipos = false;
        });
    },
    getPersonaTipos() {
      this.loadingPersonaTipos = true;
      axios
        .get("/Proveedores/ListarPersonaTipos")
        .then((response) => {
          this.personaTipos = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loadingPersonaTipos = false;
        });
    },
    getProveedorActividades() {
      this.loadingProveedorActividad = true;
      axios
        .get("/Proveedores/ListarProveedorActividades")
        .then((response) => {
          this.proveedorActividades = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loadingProveedorActividad = false;
        });
    },
    getRegimenFiscales() {
      axios
        .get("/Catalogos/ListarRegimenFiscales")
        .then((response) => {
          this.regimenFiscales = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loadingRegimenFiscales = false;
        });
    },
    getEstados() {
      this.loadingEstados = true;
      axios
        .get("/Catalogos/ListarEstados")
        .then((response) => {
          this.estados = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loadingEstados = false;
        });
    },
    getMunicipios() {
      if (this.editedItem.id_estado == null || this.editedItem.id_estado == 0)
        return;
      this.loadingMunicipios = true;

      axios
        .get(`/Catalogos/ListarMunicipios/${this.editedItem.id_estado}`)
        .then((response) => {
          this.municipios = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loadingMunicipios = false;
        });
    },
    getPaises() {
      this.loadingPaises = true;

      axios
        .get("/Catalogos/ListarPaises")
        .then((response) => {
          this.paises = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loadingPaises = false;
        });
    },
    getItems() {
      const url = new URL(`http://localhost/Proveedores/ListarProveedores`);
      if (this.search.id_proveedor_tipo != null) url.searchParams.append("id_proveedor_tipo",this.search.id_proveedor_tipo);
      if (this.search.nombre != null) url.searchParams.append("nombre", this.search.nombre);
      if (this.search.email != null) url.searchParams.append("email",this.search.email);
      if (this.search.rfc != null) url.searchParams.append("rfc",this.search.rfc);
      if (this.search.num_proveedor != null) url.searchParams.append("id_proveedor_tipo",this.search.num_proveedor);
      if (this.search.estado != null) url.searchParams.append("estado",this.search.estado);
      if (this.search.id_proveedor_nivel != null) url.searchParams.append("id_proveedor_nivel", this.search.id_proveedor_nivel);
      var url_string = url.href.replace("http://localhost", "");

      this.loading = true;
      axios
        .get(url_string)
        .then((response) => {
          this.items = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getRowClass(item) {
      if (item.bloqueado) return "danger-row-proveedores";
      if (!item.validado) return "pending-row-proveedores";
      return "";
    },
    openDialogAddParcial() {
      this.dialogAddEdit = true;
      this.editedItem = Object({}, this.defaultEditedItem);
    },
    closeDialogAddEdit() {
      this.editedItem = Object({}, this.defaultEditedItem);
      this.dialogAddEdit = false;
    },
    isValid() {
      // Validaciones comunes para todos los tipos
      if (!this.editedItem.id_proveedor_tipo) {
        this.$refs.alert.setMessage(
          "",
          "El campo Tipo de Proveedor es obligatorio"
        );
        this.$refs.alert.open();
        return false;
      }

      if (!this.editedItem.id_persona_tipo) {
        this.$refs.alert.setMessage(
          "",
          "El campo Tipo de Persona es obligatorio"
        );
        this.$refs.alert.open();
        return false;
      }

      if (!this.editedItem.nombre_completo) {
        this.$refs.alert.setMessage(
          "",
          "El campo Nombre comercial es obligatorio"
        );
        this.$refs.alert.open();
        return false;
      }

      if (!this.editedItem.nombre_contacto) {
        this.$refs.alert.setMessage(
          "",
          "El campo Nombre del Contacto es obligatorio"
        );
        this.$refs.alert.open();
        return false;
      }

      if (!this.editedItem.telefono) {
        this.$refs.alert.setMessage(
          "",
          "El campo Teléfono Empresarial/Sucursal es obligatorio"
        );
        this.$refs.alert.open();
        return false;
      }

      if (!this.editedItem.correo_electronico) {
        this.$refs.alert.setMessage(
          "",
          "El campo Correo Electrónico es obligatorio"
        );
        this.$refs.alert.open();
        return false;
      }

      // Validaciones específicas para Proveedor Nacional
      if (this.editedItem.id_proveedor_tipo == "34a6560f-61c4-4bd0-a778-b7e641818fd0")
      {
        if (!this.editedItem.rfc) {
          this.$refs.alert.setMessage("", "El campo RFC es obligatorio");
          this.$refs.alert.open();
          return false;
        }

        if (this.editedItem.id_persona_tipo === 'fd457b15-bbf2-4d2f-be75-6cacd26f523a' && this.editedItem.rfc.length !== 13)
        {
          this.$refs.alert.setMessage(
            "",
            "El RFC de una Persona Física debe tener 13 caracteres"
          );
          this.$refs.alert.open();
          return false;
        }

        if (this.editedItem.id_persona_tipo === '1e8548fd-a3d7-47ae-a34d-cba0ecee405c' && this.editedItem.length !== 12)
        {
          this.$refs.alert.setMessage(
            "",
            "El RFC de una Persona Moral debe tener 12 caracteres"
          );
          this.$refs.alert.open();
          return false;
        }

        if (!this.editedItem.id_proveedor_actividad) {
          this.$refs.alert.setMessage(
            "",
            "El campo Tipo de Proveedor Nacional es obligatorio"
          );
          this.$refs.alert.open();
          return false;
        }

        if (!this.editedItem.id_regimen_fiscal) {
          this.$refs.alert.setMessage(
            "",
            "El campo Régimen Fiscal es obligatorio"
          );
          this.$refs.alert.open();
          return false;
        }

        if (!this.editedItem.id_estado) {
          this.$refs.alert.setMessage("", "El campo Estado es obligatorio");
          this.$refs.alert.open();
          return false;
        }

        if (!this.editedItem.id_municipio) {
          this.$refs.alert.setMessage("", "El campo Municipio es obligatorio");
          this.$refs.alert.open();
          return false;
        }

        if (!this.editedItem.localidad) {
          this.$refs.alert.setMessage("", "El campo Localidad es obligatorio");
          this.$refs.alert.open();
          return false;
        }

        if (!this.editedItem.colonia) {
          this.$refs.alert.setMessage("", "El campo Colonia es obligatorio");
          this.$refs.alert.open();
          return false;
        }
      }

      // Validaciones específicas para Proveedor Internacional
      if (this.editedItem.id_proveedor_tipo == "4ae22cb8-3564-41e9-a726-302cb6762e02")
      {
        if (!this.editedItem.numero_fiscal) {
          this.$refs.alert.setMessage(
            "",
            "El campo Número de Identificación Fiscal es obligatorio"
          );
          this.$refs.alert.open();
          return false;
        }

        if (!this.editedItem.ciudad) {
          this.$refs.alert.setMessage("", "El campo Ciudad es obligatorio");
          this.$refs.alert.open();
          return false;
        }

        if (!this.editedItem.region) {
          this.$refs.alert.setMessage(
            "",
            "El campo Región/Estado/Provincia es obligatorio"
          );
          this.$refs.alert.open();
          return false;
        }

        if (!this.editedItem.id_pais) {
          this.$refs.alert.setMessage("", "El campo País es obligatorio");
          this.$refs.alert.open();
          return false;
        }
      }

      if (!this.editedItem.razon_social) {
        this.$refs.alert.setMessage(
          "",
          "El campo Nombre/Razón Social es obligatorio"
        );
        this.$refs.alert.open();
        return false;
      }

      if (!this.editedItem.calle) {
        this.$refs.alert.setMessage("", "El campo Calle es obligatorio");
        this.$refs.alert.open();
        return false;
      }

      if (!this.editedItem.num_ext) {
        this.$refs.alert.setMessage("", "El campo Núm Exterior es obligatorio");
        this.$refs.alert.open();
        return false;
      }

      if (!this.editedItem.codigo_postal) {
        this.$refs.alert.setMessage(
          "",
          "El campo Código Postal es obligatorio"
        );
        this.$refs.alert.open();
        return false;
      }

      return true;
    },
    save(){
      if(!this.isValid()) return;

      this.saving = true;

      const isNew = this.editedItem.id_proveedor == null;
      const request = isNew 
        ? axios.post('/Proveedores/CrearProveedorParcial', this.editedItem)
        : axios.put('/Proveedores/EditarProveedor', this.editedItem);

      request
        .then(() => {
          this.getItems();
          this.closeDialogAddEdit();
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.saving = false;
        })
    },
    openDialogView(item){
      this.$refs.mostrar_detalles.open(item.id_proveedor);
    },
    openDialogCuentaBancariasView(item){
      this.$refs.cuenta_bancarias.open(item.id_proveedor);
    },
  },
};
</script>


<style>
/*
.danger-row-proveedores {
  background-color: #fca5a5 !important;
  border-left: 5px solid #dc2626 !important;
  color: #7f1d1d !important;
  font-weight: 500 !important;
}
*/

.danger-row-proveedores {
  border-left: 5px solid #dc2626 !important;
}

.danger-row-proveedores td:not(:first-child):not(:last-child) {
  background: repeating-linear-gradient(
    45deg,
    #fecaca,
    #fecaca 10px,
    #fca5a5 10px,
    #fca5a5 20px
  ) !important;
  color: #7f1d1d !important;
  font-weight: 600 !important;
}

.danger-row-proveedores td:first-child,
.danger-row-proveedores td:last-child {
  background-color: white !important;
  color: inherit !important;
  font-weight: normal !important;
}

.danger-row-proveedores:hover td:not(:first-child):not(:last-child) {
  background: repeating-linear-gradient(
    45deg,
    #fca5a5,
    #fca5a5 10px,
    #f87171 10px,
    #f87171 20px
  ) !important;
}

.pending-row-proveedores {
  border-left: 5px solid #f59e0b !important;
}

.pending-row-proveedores td:not(:first-child):not(:last-child) {
  background: repeating-linear-gradient(
    45deg,
    #fffbeb,
    #fffbeb 10px,
    #fef3c7 10px,
    #fef3c7 20px
  ) !important;
  color: #92400e !important;
  font-weight: 500 !important;
}

.pending-row-proveedores td:first-child,
.pending-row-proveedores td:last-child {
  background-color: white !important;
  color: inherit !important;
  font-weight: normal !important;
}

.pending-row-proveedores:hover td:not(:first-child):not(:last-child) {
  background: repeating-linear-gradient(
    45deg,
    #fef3c7,
    #fef3c7 10px,
    #fde68a 10px,
    #fde68a 20px
  ) !important;
}
</style>